<template>
  <div>
    <legacy @displayBandsIntro="goToIntro"></legacy>
    <bottom-action-container>
      <btn-skip @navClicked="goToDashboard"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous"/>
          <btn text="Go To Dashboard" type="primary" @click="goToDashboard"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import Legacy from './LegacyWithMonth.vue'
export default {
  name: 'LegacyWithMonth',
  components: {
    Legacy
  },
  methods: {

    /* function to show intro */
    goToIntro() {
      this.$emit('displayIntro');
    },

    /* function to go back to previous page */
    previous() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/employeeDashboard`)
    },

    goToDashboard() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll`
      });
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
</style>
